import './App.css';
import Header from './components/Header';
import Converter from './components/Converter';

const App = () => {

  return (
    <div>
      <Header />
      <Converter />
    </div>
  )
}

export default App